import log from 'salvo-lite/log'

class DropdownMenu {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._overlay = elem.querySelector('[data-overlay]')
        this._dropdownOpen = false

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._overlay.addEventListener('click', () => {
            const dropdownItems = this._elem.querySelectorAll('.account__column-btn')

            if (this._dropdownOpen) {
                dropdownItems.forEach(item => {
                    const newItem = item.cloneNode(true)

                    if (item.classList.contains('active')) {
                        newItem.classList = 'account__column-btn active'
                    } else {
                        newItem.classList = 'account__column-btn'
                    }

                    item.parentNode.replaceChild(newItem, item)
                })

                this._dropdownOpen = false
            } else {
                let counter = 0

                dropdownItems.forEach((item, i) => {
                    if (!item.classList.contains('active')) {
                        item.classList.add('_' + counter)
                        counter++
                    }

                    item.addEventListener('click', event => {
                        dropdownItems.forEach(item => {
                            item.classList = 'account__column-btn'
                        })

                        event.target.classList.add('active')
                        this._dropdownOpen = false
                    })
                })

                this._dropdownOpen = true
            }
        })
    }
}

export default DropdownMenu



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DropdownMenu.js